<script setup lang="ts">
import ContactFormWrapper from "@/shared/components/ContactFormWrapper.vue";

/**
 * InteractContactFormWrapper - Interact Form専用
 *
 * 基底クラスContactFormWrapperを使用し、
 * interact-form専用のスタイリング（Figmaデザイン準拠）を適用
 */
defineProps<{
	contactformHtml: string;
	processedHtml: string;
}>();
</script>

<template>
  <div class="interact-contact-form-wrapper">
    <ContactFormWrapper 
      :contactformHtml="contactformHtml" 
      :processedHtml="processedHtml" 
    />
  </div>
</template>

<style lang="scss" scoped>
.interact-contact-form-wrapper {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  :deep(.contact-form-base) {
    height: 100%;
    width: 100%;
  }

  // 送信ボタンを非表示（親コンポーネントのカスタムボタンを使用）
  :deep(.wpcf7-submit) {
    display: none;
  }
}
</style>